import { useTranslation } from '@/app/i18n/client'

const AdVertiseHeader = () => {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-center">
      <ul className="flex gap-[30px] ml-[50px] mb-[10px] text-[14px]">
        <li>{t('Buyers Alert')}</li>
        <li>{t('Sales Offers')}</li>
        <li>{t('News')}</li>
        <li className="font-ns_bold">{t('Register your Company')}</li>
        <li>{t('Events')}</li>
        <li>{t('Retail Partners')}</li>
        <li>{t('Solutions')}</li>
        <li>{t('About Us')}</li>
        <li>{t('Advertise')}</li>
      </ul>
    </div>
  )
}

export default AdVertiseHeader
